import { applyAuth0Theme } from "@/utils/theme";

import ResendEmail from "./components/ResendEmail";
import { useResetPasswordEmailManager } from "./hooks/useResetPasswordEmailManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function ResetPasswordEmailScreen() {
    // Extracting attributes from hook made out of ResetPasswordEmailInstance class of Auth0 React SDK
    const { resetPasswordEmail, texts, locales } = useResetPasswordEmailManager();

    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(resetPasswordEmail);
    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>

            <ResendEmail />

        </AuthLayout>
    );
}

export default ResetPasswordEmailScreen;
